// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBuNmBZhke5jzyBh8SvUY_DdnRISHJCzrU",
  authDomain: "sms-receiver-ee3cb.firebaseapp.com",
  projectId: "sms-receiver-ee3cb",
  storageBucket: "sms-receiver-ee3cb.appspot.com",
  messagingSenderId: "493897967810",
  appId: "1:493897967810:web:cea0e7fde570dbe43e735b",
  measurementId: "G-NQGRWCH97F"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
